import { Service, BaseService } from "@/core/auto";

@Service('/api/usr/elearningInfo')
export default class ElearningInfo extends BaseService {
	init(data) {
		return this.request({
			data: data,
			url: "/init",
			method: "POST"
		});
	}

	studyStart(data) {
		return this.request({
			data: data,
			url: "/studyStart",
			method: "POST"
		});
	}
}
